import React from 'react'
import PageBody from '../../components/pagebody/PageBody'
import DeveloperHub from './developerhub/DeveloperHub'
import { Navigate, Route, Routes } from 'react-router-dom'
import ApiHub from './apihub/ApiHub'
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks'
import { componentKey } from './ApiSlice'
import { componentKey as authenticationComponentKey} from '../authentication/AuthenticationSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getAPIDetails } from './ApiSaga'
import useTxNavigate from '../../../libs/txnavigate/TxNavigateHook'

export default function ApiSection() {
	useGarbageCollector(componentKey)

	const { signedInUser } = useSelector(state => state[authenticationComponentKey]);
	const dispatch = useDispatch();
	const navigate = useTxNavigate();
	
	useEffect(() => {
		if(signedInUser?.UserType == 1 || signedInUser?.UserType == 3){
			dispatch(getAPIDetails())
		}else{
			navigate('/')
		}
	}, [])

	return (
		<PageBody>
			<Routes>
				<Route path="/apihub" element={<ApiHub />} />
				<Route path="/developerhub/*" element={<DeveloperHub />} replace={true} />
				<Route path={'/*'} element={<Navigate to={`/api/apihub`} replace={true} />} />
			</Routes>
		</PageBody>
	)
}